import * as Yup from 'yup';
import { isSequentialOrRepeatable } from '../utils/index';
import { getLocalizedStrings } from '../misc';

const updatePasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .required(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { PASSWORD_REQUIRED }
          }
        }
      } = getLocalizedStrings();
      return PASSWORD_REQUIRED;
    })
    .matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { PASSWORD_MATCHES }
          }
        }
      } = getLocalizedStrings();
      return PASSWORD_MATCHES;
    })
    .test(
      'password',
      () => {
        const {
          USERS: {
            USER_AUTHENTICATION: {
              REGISTRATION_SCHEMA_MESSAGES: { PASSWORD_REPEAT }
            }
          }
        } = getLocalizedStrings();
        return PASSWORD_REPEAT;
      },
      isSequentialOrRepeatable
    ),
  confirmPassword: Yup.string()
    .required(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            UPDATE_PASSWORD_SCHEMA: { CONFIRM_PASS }
          }
        }
      } = getLocalizedStrings();
      return CONFIRM_PASS;
    })
    .when('newPassword', {
      is: val => !!(val && val.length > 0),
      then: Yup.string().oneOf([Yup.ref('newPassword')], () => {
        const {
          USERS: {
            USER_AUTHENTICATION: {
              UPDATE_PASSWORD_SCHEMA: { BOTH_PASS_SAME }
            }
          }
        } = getLocalizedStrings();
        return BOTH_PASS_SAME;
      })
    })
});

export default updatePasswordSchema;
